(() => {
  const selector = '.jdgm-text, .jdgm-rev__body, .jdgm-rev__title';
  const emoji = /(?:\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})?)*|\p{Regional_Indicator}{2}|[0-9#*]\uFE0F?\u20E3)/gu;
  function clean(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, textarea, [contenteditable="true"]')) continue;
      const value = node.nodeValue.replace(emoji, match => /^[©®™]/u.test(match) ? match : '');
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }
  function scan(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const review = element.closest(selector);
    if (review) clean(review);
    else element.querySelectorAll(selector).forEach(clean);
  }
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();